document.addEventListener("DOMContentLoaded", function () {
  const feeds = [
    { url: "https://blog.maphabit.com/blog/rss.xml", category: "Blog" },
    { url: "https://blog.maphabit.com/research/rss.xml", category: "Research" },
    { url: "https://blog.maphabit.com/press-releases/rss.xml", category: "Press" }
  ];

  Promise.all(feeds.map(feed =>
    fetch(feed.url)
      .then(res => res.text())
      .then(str => {
        const xml = new window.DOMParser().parseFromString(str, "text/xml");
        const items = Array.from(xml.querySelectorAll("item")).map(item => {
          const rawDescription = item.querySelector("description")?.textContent ?? "";
          return {
            title: item.querySelector("title").textContent,
            link: item.querySelector("link").textContent,
            pubDate: new Date(item.querySelector("pubDate").textContent),
            description: rawDescription,
            excerpt: stripHTML(rawDescription).slice(0, 300), // limit to 300 chars
            image: extractImageFromItem(item),
            category: feed.category,
            author: item.querySelector("dc\\:creator")?.textContent || "MapHabit"
          };
        });
        return items;
      })
  )).then(results => {
    const allPosts = results.flat().sort((a, b) => b.pubDate - a.pubDate).slice(0, 10);
    const [featured, ...sidebarPosts] = allPosts.slice(0, 6);

    renderFeaturedPost(featured);
    renderSidebarPosts(sidebarPosts.slice(0, 5));
    renderViewAllLink();
  }).catch(err => {
    console.error("RSS Feed Error:", err);
    const featured = document.getElementById("rss-featured-post");
    const sidebar = document.getElementById("rss-sidebar-posts");
    if (featured) featured.innerHTML = "<p>Could not load featured post.</p>";
    if (sidebar) sidebar.innerHTML = "<p>Could not load more posts.</p>";
  });

  function renderFeaturedPost(post) {
    const container = document.getElementById("rss-featured-post");
    if (!container) return;

    container.innerHTML = `
      <div class="rss-featured-inner">
        <div class="featured-image-container">
          <img src="${post.image}" alt="${post.title}">
          <span class="category-badge">${post.category}</span>
        </div>
        <p class="meta">${post.pubDate.toLocaleDateString()} • ${post.author}</p>
        <h2>${post.title}</h2>
        <p class="excerpt">${post.excerpt}</p>
        <a href="${post.link}" class="read-more" target="_blank">Read more</a>
      </div>
    `;
  }

  function renderSidebarPosts(posts) {
    const container = document.getElementById("rss-sidebar-posts");
    if (!container) return;
    container.innerHTML = posts.map(post => `
      <div class="sidebar-post">
        <img class="thumb" src="${post.image}" alt="${post.title}">
        <div class="sidebar-post-info">
          <span class="sidebar-category">${post.category}</span>
          <h4>${post.title}</h4>
        </div>
        <a href="${post.link}" target="_blank" class="arrow-link">→</a>
      </div>
    `).join("");
  }

  function renderViewAllLink() {
    const container = document.getElementById("rss-sidebar-posts");
    const linkHTML = `<div class="view-all-link"><a href="https://blog.maphabit.com" target="_blank">View all blog posts →</a></div>`;
    container.insertAdjacentHTML('beforeend', linkHTML);
  }
});

// 👇 Utility: strip <img> tags + all HTML
function stripHTML(input) {
  const noImg = input.replace(/<img[^>]*>/gi, "");
  return noImg.replace(/<\/?[^>]+(>|$)/g, "").trim();
}

// 👇 Extract image logic
function extractImageFromItem(item) {
  let img = item.querySelector("media\\:content, enclosure")?.getAttribute("url");
  if (img) return img;

  const descHTML = item.querySelector("description")?.textContent ?? "";
  const match = descHTML.match(/<img.*?src=["'](.*?)["']/);
  if (match && match[1]) return match[1];

  return "";
}
